/**
 * CloudFront の signed URL で使用する署名（Base64 エンコード文字列）を、
 * URL に安全に埋め込めるようにするための URL-safe 変換を行う。
 *
 * CloudFront ドキュメントに記載されているとおり、署名文字列中の
 * `+`, `=`, `/` をそれぞれ `-`, `_`, `~` に置き換える。
 * これは一般的な URL-safe Base64（`+`→`-`, `/`→`_` など）とは
 * 異なる CloudFront 独自の仕様である点に注意すること。
 * @see https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/private-content-creating-signed-url-custom-policy.html#private-content-custom-policy-creating-signature
 */
export const toUrlSafeForSignedUrl = (str: string): string =>
  str.replace(/\+/g, "-").replace(/=/g, "_").replace(/\//g, "~");
